import React, {useState, useCallback} from 'react'
import {validateField} from '../config'

export const TextInput = ({
  config,
  currentValue,
  onChange,
  placeholder = 'Enter value',
  isValid,
  setIsValid,
}) => {
  const [error, setError] = useState('')
  const [touched, setTouched] = useState(false)

  const validate = useCallback(
    value => {
      if (!config?.validation) return {isValid: true, message: ''}
      return validateField(value, config.validation)
    },
    [config?.validation],
  )

  const handleChange = e => {
    const newValue = e.target.value
    onChange(newValue)

    if (config?.validation) {
      let valid = true
      let message = ''
      if (newValue === '' && config.required) {
        valid = false
        message = 'This field is required.'
      } else {
        const result = validate(newValue)
        valid = result.isValid
        message = result.message
      }
      if (setIsValid) setIsValid(valid)
      if (touched) {
        setError(valid ? '' : message)
      }
    }
  }

  const handleBlur = () => {
    setTouched(true)
    if (config?.validation) {
      let valid = true
      let message = ''
      if ((currentValue === '' || currentValue == null) && config.required) {
        valid = false
        message = 'This field is required.'
      } else {
        const result = validate(currentValue)
        valid = result.isValid
        message = result.message
      }
      if (setIsValid) setIsValid(valid)
      setError(valid ? '' : message)
    }
  }

  const hasError = touched && error

  return (
    <div className="custom-field-wrapper">
      <label className="custom-field-label">
        <span className="custom-field-label-text">{config?.label}</span>
        <input
          type="text"
          className={`custom-field-input${
            hasError ? ' custom-field-input-error' : ''
          }`}
          value={currentValue}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={config?.placeholder || placeholder}
          aria-invalid={isValid === false}
        />
      </label>
      {hasError && <span className="custom-field-error-text">{error}</span>}
    </div>
  )
}
